export default __webpack_public_path__ + "static/media/workinprogress1.1d405748.jpg";